import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'

import type { ReactElement } from 'react'
import 'react-circular-progressbar/dist/styles.css'

import './styles.scss'

type IVariant = 'primary' | 'secondary'

interface Props {
  value: number
  variant?: IVariant
}

const colors: Record<IVariant, string> = {
  primary: '#06703d',
  secondary: '#fdbf4e',
}

const CircularProgress = ({ value, variant = 'primary' }: Props): ReactElement => {
  return (
    <div className="circular-progress-component">
      <CircularProgressbar
        styles={buildStyles({
          pathColor: colors[variant],
          textColor: colors[variant],
        })}
        text={String(value)}
        value={value}
      />
    </div>
  )
}

export default CircularProgress
